import axios from 'axios';

const http = axios.create({
    baseURL: 'https://a5-dashboard.herokuapp.com/'
    // baseURL: 'http://localhost:2813'
});

export default http;



// WEBPACK FOOTER //
// ./src/services/http.js